import React, { Component } from 'react';
import Header from './Header';
import MessageArea from './MessageArea';
import Body from './Body';
import Processing from './Processing';
import './Contents.css';

class Contents extends Component {
  render() {
    const {
      history,
    } = this.props;
    const path = history && history.location && history.location.pathname;

    return (
      <div className="main">
        <Header />
        <div className={`${path}` === '/searchcompany' ? 'searchcompanybody' : 'body'}>
          { `${path}` !== '/searchcompany' ? <MessageArea /> : null}
          <Body />
        </div>
        <Processing />
      </div>
    );
  }
}

export default Contents;
